import { useQuery } from 'react-query';
import { branchOfficeService } from 'hq/services';
import { QUERY_KEYS } from 'api/query-keys';

const useGetAllActiveBranchOffices = () => {
  const queryFn = async () => await branchOfficeService.getAllActiveBranchOffices();

  return useQuery(QUERY_KEYS.branchOfficesActive(), queryFn, {});
};

export { useGetAllActiveBranchOffices };
